"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkColumns = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FooterLink_atom_1 = require("../atoms/FooterLink.atom");
const Subtitle_atom_1 = require("../atoms/Subtitle.atom");
const Styled = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: flex-start;
	justify-content: flex-start;
	align-items: flex-start;

	&.ar {
		.column {
			margin-right: initial;
			margin-left: 32px;
		}
	}

	a {
		padding-left: 0;
		display: block;
	}

	.column {
		display: inline-block;
		margin-right: 32px;
		${(p) => p.theme.breakpoints.up("lg")} {
			min-width: 160px;
		}
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		align-content: center;
		justify-content: space-evenly;
		flex-wrap: wrap;
		.column {
			margin-right: 0;
			margin-bottom: 32px;
		}
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		&.half-width .column {
			//not 50 to prevent overflow on xs
			width: 45%;
		}
		.column.hanging {
			min-width: 100%;
		}
	}
`;
const LinkColumns = ({ linkColumns = [], locale }) => {
    // allow 2 columns together in one row, break apart if greater than 2
    const halfWidth = linkColumns.length > 2;
    return (react_1.default.createElement(Styled, { className: (0, classnames_1.default)("link-columns", locale, { "half-width": halfWidth }) }, linkColumns.map((linkColumn, i) => {
        const { subTitle, links = [] } = linkColumn;
        //if last row only has one column give it the hanging class
        const hanging = halfWidth && i === linkColumns.length - 1 && linkColumns.length % 2 !== 0;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("column", { hanging }), key: `link-col-${i}` },
            react_1.default.createElement(Subtitle_atom_1.Subtitle, { subTitle: subTitle }),
            links.map((link) => {
                return react_1.default.createElement(FooterLink_atom_1.FooterLink, Object.assign({ key: link.title }, link));
            })));
    })));
};
exports.LinkColumns = LinkColumns;
//# sourceMappingURL=LinkColumns.molecule.js.map